import {Component, OnInit} from '@angular/core';
import {PromotionTemplateModel} from '../../../models/promotion-template.model';
import {PromotionTemplateService} from '../../../services/promotion/promotion-template.service';

@Component({
  selector: 'kv-promo-template',
  template: `
    <app-kontable
      title="{{ 'promotion.template' | translate }}"
      [columns]="['id', 'code', 'description']"
      [titles]="['#', 'promotion.code', 'promotion.description']"
      [source]="templates"
      [showInfoButton]="true"
      [showRecoverButton]="false"
      [showDetailsButton]="false"
      [showAddButton]="true"
      [showGlobalFilter]="false"
      (onAdd)="showAdd()"
      (onEdit)="showEdit($event)"
      (onRemove)="delete($event)"
      *ngIf="!show">
    </app-kontable>
    <kv-promo-template-detail
      *ngIf="show"
      [titlePage]="titlePage"
      [template]="addEditTemplate"
      (hide)="toggleShow()"
      (saveTemplate)="saveTemplate($event)">
    </kv-promo-template-detail>
  `
})
export class TemplateComponent implements OnInit {

  addEditTemplate: any;
  titlePage = '';
  show = false;
  templates: PromotionTemplateModel[];

  constructor(private svcTemplate: PromotionTemplateService) {
    this.svcTemplate.list().subscribe((res) => {
      this.templates = res.data;
    });
  }

  ngOnInit(): void {}

  saveTemplate(item) {
    if (!item.id) {
      /*Creazione nuovo template*/
      this.svcTemplate.create({
        code: item.code,
        description: item.description,
        flg_type_template: item.flg_type_template
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditTemplate = null;
        this.toggleShow();
        this.reloadList();
      });
    }else {
      /*Modifica template esistente*/
      this.svcTemplate.update({
        id: item.id,
        code: item.code,
        description: item.description,
        flg_type_template: item.flg_type_template
      }).subscribe(() => {
        this.titlePage = '';
        this.addEditTemplate = null;
        this.toggleShow();
        this.reloadList();
      });
    }
  }

  toggleShow() {
    this.show = !this.show
  }

  delete(item) {
    this.svcTemplate.delete(item.id).subscribe(() => {
      this.reloadList();
    })
  }

  showEdit(item) {
    this.titlePage = 'promotion.editTemplate';
    this.svcTemplate.get(item.id).subscribe((res) => {
      this.addEditTemplate = res;
      this.toggleShow();
    })
  }

  showAdd() {
    this.titlePage = 'promotion.addTemplate';
    this.addEditTemplate = {
      code: '',
      description: '',
      flg_type_template: false
    };
    this.toggleShow();
  };

  reloadList() {
    this.templates = [];
    this.svcTemplate.list(0, 999999).subscribe( res => {
      this.templates = res.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/template/template.component.ts